import {
  MINTED_ASSET_STATUSES,
  TOKENIZABLE_ASSET_STATUSES,
  delay,
  formatPreparedPayload,
  parseSignedTransactionInput
} from '../blockchain/offlineSigning';

export const BULK_MINT_METADATA_READY = new Set(['MetadataPinnedToIpfs', 'metadata_pinned_to_ipfs']);

export function normalizeBulkMintPrepareResponse(data) {
  const rows = data?.items ?? data?.Items ?? [];
  return {
    bulkRegistrationId: data?.bulkRegistrationId ?? data?.BulkRegistrationId,
    items: rows.map((row) => ({
      assetId: row.assetId ?? row.AssetId,
      prepared: row.prepared ?? row.Prepared
    }))
  };
}

export function bulkRegistrationMembers(b) {
  return b?.assets ?? b?.Assets ?? [];
}

export function isMintReadyApiAsset(a) {
  if (!a) return false;
  const tid = a.tokenizationId ?? a.TokenizationId;
  if (tid) return false;
  const s = a.status ?? a.Status ?? '';
  return TOKENIZABLE_ASSET_STATUSES.has(s) || BULK_MINT_METADATA_READY.has(s);
}

export function memberDocumentsCount(a) {
  const docs = a?.documents ?? a?.Documents ?? [];
  return Array.isArray(docs) ? docs.length : 0;
}

export function bulkTotalDocCount(br) {
  return bulkRegistrationMembers(br).reduce((sum, a) => sum + memberDocumentsCount(a), 0);
}

export function latestMintRequestFromMemberHistory(entry) {
  const reqs = entry?.mintRequests ?? entry?.MintRequests ?? [];
  return Array.isArray(reqs) && reqs.length > 0 ? reqs[0] : null;
}

export function formatMintRequestStatus(status) {
  const lower = String(status ?? '').trim().toLowerCase();
  if (!lower) return '—';
  const map = {
    confirmed: 'Confirmed',
    failed: 'Failed',
    submittedtoblockchain: 'Submitted (pending)',
    validated: 'Validated',
    created: 'Created'
  };
  return map[lower] || String(status);
}

/** Backend allows re-broadcast for non-terminal success rows (same stored raw tx). */
export function mintRequestAllowsRebroadcast(status) {
  const s = String(status ?? '').toLowerCase();
  return s === 'failed' || s === 'validated' || s === 'submittedtoblockchain' || s === 'created';
}

export function shortenTxHash(hash) {
  const h = String(hash ?? '').trim();
  if (!h) return '';
  if (h.length <= 18) return h;
  return `${h.slice(0, 10)}…${h.slice(-8)}`;
}

/** Newest-first list: prefer latest confirmed mint, else latest row with a tx hash. */
export function preferredMintRequestForDisplay(mintRequests) {
  const list = Array.isArray(mintRequests) ? mintRequests : [];
  if (list.length === 0) return null;
  const st = (r) => String(r?.status ?? r?.Status ?? '').toLowerCase();
  const confirmed = list.find((r) => st(r) === 'confirmed');
  if (confirmed) return confirmed;
  const withTx = list.find((r) => String(r?.transactionHash ?? r?.TransactionHash ?? '').trim());
  if (withTx) return withTx;
  return list[0];
}

export { delay, formatPreparedPayload, parseSignedTransactionInput, MINTED_ASSET_STATUSES };
